<template>
  <div class="rounded overflow-hidden flex flex-col items-center border border-b-none border-gray-200 pt-6 sm:max-w-80 shadow-sm bg-gray-50">
    <label class="w-full uppercase block text-center">Enter Your Bib Number</label>

    <input
      v-model="searchParams.search"
      type="text"
      placeholder="0000"
      class="bg-transparent rounded-none mb-0 focus:ring-0 ring-0 text-5xl sm:text-6xl placeholder:text-gray-200 border-0 py-3 sm:py-10 text-center font-mono"
      @input="handleInput"
      @keyup.enter="() => { searchParams.category = null; $emit('search') }"
    >

    <AppButton
      class="btn btn-solid btn-secondary h-10 sm:h-14 rounded-none w-full"
      @click="() => { searchParams.category = null; $emit('search') }"
    >
      Search
    </AppButton>
  </div>
</template>

<script setup>

import { AppButton } from '@/components/app';

const searchParams = defineModel();

defineEmits(['search']);

const handleInput = (event) => {
  // Remove all non-numeric characters
  const numericValue = event.target.value.replace(/\D/g, '');
  // Limit to 5 characters
  searchParams.value.search = numericValue.slice(0, 5);
};

</script>
